import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { AsyncReducerStatus } from 'store/common/AsyncReducerStatus';
import { useTypedSelector } from 'store/common/TypedSelector';

import { ModalDialogue } from 'presentation/ui/compositions/modal-dialogue/ModalDialogue';
import { ModalDialogueHeight } from 'presentation/ui/compositions/modal-dialogue/ModalDialogueHeight';
import { CyclotronProductViewModel } from 'services/nuclide/domain/model/CyclotronProductModel';
import { CyclotronProductModelState } from 'services/nuclide/domain/model/CyclotronProductModelState';
import { updateCyclotronProduct } from 'services/nuclide/store/cyclotronProductSlice';
import { CyclotronProductUndoCompletelyAppliedForm } from '../cyclotron-product-undo-completely-applied-form/CyclotronProductUndoCompletelyAppliedForm';
import { CyclotronProductUndoCompletelyAppliedFailedNotification } from './CyclotronProductUndoCompletelyAppliedFailedNotification';


export interface CyclotronProductUndoCompletelyAppliedModalProps {
	/**
	 * Cyclotron product
	 */
	cyclotronProduct: CyclotronProductViewModel
	/**
	 * Handle dismiss
	 */
	onDismiss?: () => void;
}

export const CyclotronProductUndoCompletelyAppliedModal = (props: CyclotronProductUndoCompletelyAppliedModalProps): JSX.Element => {
	const { cyclotronProduct, onDismiss } = props;

	const cyclotronProductActionStatus = useTypedSelector(state => state.cyclotronProducts.actionStatus);

	const dispatch = useDispatch();

	useEffect(() => {
		if (cyclotronProductActionStatus === AsyncReducerStatus.UPDATED) {
			onDismiss();
		}
	}, [cyclotronProductActionStatus, onDismiss]);

	const handleUpdate = (): void => {
		cyclotronProduct.State = CyclotronProductModelState.ACTIVE;
		dispatch(updateCyclotronProduct(cyclotronProduct));
	};

	const renderModalContent = () => {
		let modalContent: JSX.Element = null;

		switch (cyclotronProductActionStatus) {
			case AsyncReducerStatus.IDLE:
				modalContent =
					<CyclotronProductUndoCompletelyAppliedForm
						cyclotronProduct={cyclotronProduct}
						onUpdate={handleUpdate}
						onDismiss={onDismiss}
					/>;
				break;

			case AsyncReducerStatus.FAILED:
				modalContent = <CyclotronProductUndoCompletelyAppliedFailedNotification
					onDismiss={onDismiss}
				/>;
				break;
		}

		return modalContent;
	};

	return (
		<ModalDialogue height={ModalDialogueHeight.HEIGHT_FLEX}>
			{renderModalContent()}
		</ModalDialogue>
	);
};
